export default __webpack_public_path__ + "static/media/per-four.7736dcef.svg";